import { get, values } from 'lodash/fp';
import { createSelector } from 'reselect';

export const getAvailability = get('inventory.itemAvailability');

export const getAvailabilityByUniqId = createSelector(
  getAvailability,
  get('byUniqId')
);

export const getAvailabilityByItemId = createSelector(
  getAvailability,
  get('byItemId')
);

export const getAvailabilityForItemId = createSelector(
  (_, itemId) => itemId,
  getAvailabilityByItemId,
  get
);

export const getAvailabilities = createSelector(
  getAvailabilityByUniqId,
  values
);

export const getIsFetching = createSelector(getAvailability, get('fetching'));
export const getIsFetched = createSelector(getAvailability, get('fetched'));
export const getFetchingError = createSelector(
  getAvailability,
  get('fetchingError')
);

export const getIsSaving = createSelector(getAvailability, get('saving'));
export const getIsSaved = createSelector(getAvailability, get('saved'));
export const getSavingError = createSelector(
  getAvailability,
  get('savingError')
);

export const getIsFetchingByItem = createSelector(
  getAvailability,
  get('fetchingByItem')
);

export const getIsFetchingByItemError = createSelector(
  getAvailability,
  get('fetchingByItemError')
);

export const getIsDeleting = createSelector(getAvailability, get('deleting'));

export const getIsDeleted = createSelector(getAvailability, get('deleted'));

export const getOrder = createSelector(getAvailability, get('order'));
